import { StyleSheet } from 'react-native'
import { Metrics } from 'APP/Themes'

export default StyleSheet.create({
  container: {
    paddingBottom: Metrics.baseMargin,
  },
  loading: {
    flex: 1,
    justifyContent: 'center',
    alignContent: 'center',
  },
  refresh: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
  section: {
    minHeight: 200,
    paddingHorizontal: Metrics.baseMargin,
  },
  sectionHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingTop: Metrics.baseMargin * 1.5,
    paddingBottom: Metrics.baseMargin,
    paddingLeft: Metrics.baseMargin * 1.5,
  },
  row: {
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  empty: {
    marginTop: Metrics.baseMargin * 5,
    paddingHorizontal: Metrics.baseMargin * 2,
  },
  emptyTitle: {
    marginBottom: Metrics.baseMargin * 1.25,
  },
})
